var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImmunizations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 40,
    height: 40,
    rx: 7,
    fill: "#959CA0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8516 17.3359L19.0391 19.5234C19.1562 19.6406 19.1562 19.8359 19.0391 19.9531L18.5703 20.4219C18.4531 20.5391 18.2578 20.5391 18.1406 20.4219L15.9531 18.2344L14.1953 19.9922L16.3828 22.1797C16.5 22.2969 16.5 22.4922 16.3828 22.6094L15.9531 23.0781C15.8359 23.1953 15.6016 23.1953 15.4844 23.0781L13.3359 20.8906L12.2812 21.9062C11.6172 22.5703 11.3047 23.5078 11.3828 24.4453L11.6562 26.9453L9.07812 29.5234C8.96094 29.6797 8.96094 29.875 9.07812 29.9922L9.50781 30.4219C9.625 30.5391 9.82031 30.5391 9.9375 30.4219L12.5547 27.8438L15.0156 28.1172C15.9531 28.1953 16.8906 27.8828 17.5938 27.2188L24.7031 20.1094L19.3906 14.7969L16.8516 17.3359ZM28.8828 13.7031L25.7969 10.6172C25.6797 10.5 25.4844 10.5 25.3672 10.6172L24.8984 11.0469C24.7812 11.1641 24.7812 11.3594 24.8984 11.4766L26.0312 12.6094L24.2344 14.3672L22.0469 12.1406L21.3828 11.4766C21.2656 11.3594 21.0703 11.3594 20.9531 11.4766L19.625 12.8047C19.5078 12.9219 19.5078 13.1172 19.625 13.2734L20.2891 13.9375L25.5625 19.2109L26.2266 19.875C26.3438 20.0312 26.5781 20.0312 26.6953 19.875L28.0234 18.5469C28.1406 18.4297 28.1406 18.2344 28.0234 18.1172L25.1328 15.2656L26.8906 13.4688L28.0234 14.6016C28.1406 14.7188 28.3359 14.7188 28.4531 14.6016L28.8828 14.1328C29 14.0156 29 13.8203 28.8828 13.7031Z",
    fill: "#C080B1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImmunizations);
export default __webpack_public_path__ + "static/media/immunizations.919199f5.svg";
export { ForwardRef as ReactComponent };